import { firebaseApp } from '../firebase'

const Storage = firebaseApp.storage()

export const uploadFile = (file, path, onSnapshot, onError, onComplete) => {
  const uploadTask = Storage
    .ref(path)
    .put(file)

  uploadTask.on('state_changed', onSnapshot, onError, onComplete.bind(this, uploadTask))
}
